import React, {FC, ReactElement, useState} from 'react';
import styled from 'styled-components';
import { environment } from '../../../../environments/environment';
import { useDesignSystemVar } from '../../../hooks/useDesignSystemVar';
import { parser } from './parser';


type CopyToClipboardProps = {
    elementData: {[key: string]: any};
}

const Copy = styled.div`
    cursor:pointer;
    img {
        width: 14px;
        height: auto;
    }
`;


const CopyToClip:FC<CopyToClipboardProps> = ({...props}) : ReactElement => {
    const environmentLink: string = environment().assetsLink;
    const fontFamily: string|undefined = useDesignSystemVar('var(--title-font)');
    const [ copied, setCopied ] = useState(false);

    function copySlideToClipboard() {
        const parsed = parser(props.elementData.chartType, {...props.elementData, fontFamily});
        const chart = JSON.stringify(parsed.option);
        navigator.clipboard.writeText(chart);
        setCopied(true);
        setTimeout(() => setCopied(false), 1000)
    }
  
    return (
        <Copy className={'copy'} onClick={() => copySlideToClipboard()}>
            {
                copied
                ?  (<img src={environmentLink + '/assets/images/Options/check.svg'} alt="Check" className='check' />)
                : (<img src={environmentLink + '/assets/images/Options/code.svg'} alt="Copy to clipboard" className='copy' />)
            }
        </Copy>
    )
}


export default CopyToClip;
